import * as signalR from "@microsoft/signalr";
import { RequestDomain } from "../based/RequestDomain";

const connection = new signalR.HubConnectionBuilder().withAutomaticReconnect().withUrl(`${RequestDomain.APIUrl()}/hubs/gameHub`).build();

export default connection;
